import { useProductPageStore } from '../../contexts/ProductPageStore'
import styles from './compare.module.scss'

import React, { useContext, useEffect, useState } from 'react'

import { RecommendationProvider } from 'Clutch/Stores/RecommendationStore/RecommendationStore'
import { useRecommendationSection, useRecommendationStore } from 'Clutch/Stores/RecommendationStore/RecommendationStore'
import ErrorBoundary from 'Clutch/UtilityComponents/ErrorBoundary'

import useFeatureFlag from 'Clutch/Hooks/useFeatureFlag'

import RecommendationSection from 'Clutch/Organisms/RecommendationSection/RecommendationSection'

const ProductCompare = ({ stickyHeaderRef }) => {
  const compareEnabled = useFeatureFlag('PDP_Compare_Tool')
  const skuBaseNumber = useProductPageStore((x) => x.skuBaseNumber)
  const skuVariantNumber = useProductPageStore((x) => x.skuVariantNumber)

  if (!!!compareEnabled) return false

  //adding these guards for Carson Smith, need to wire up blacklist recommendations for compare tool
  if (skuBaseNumber == '9105415') return false

  if (skuBaseNumber == '9101034') return false

  return (
    <div ref={stickyHeaderRef}>
      <ErrorBoundary>
        <RecommendationProvider
          sections={['PDP_Compare']}
          skuBaseNumbers={[skuBaseNumber]}
          skuVariantNumbers={skuVariantNumber ? [skuVariantNumber] : undefined}
        >
          <div className={styles.product_compare_card}>
            <InnerCompare sectionType={'PDP_Compare'} />
          </div>
        </RecommendationProvider>
      </ErrorBoundary>
    </div>
  )
}

const InnerCompare = ({ sectionType }) => {
  const isLoading = useRecommendationStore((x) => x.isLoading)
  const section = useRecommendationSection(sectionType)

  const setIsCompareToolPresent = useProductPageStore((x) => x.setIsCompareToolPresent)
  const scrollToTopAndStartNavigation = useProductPageStore((x) => x.scrollToTopAndStartNavigation)

  const recSkuBaseNumbers = useRecommendationStore((x) => x.skuBaseNumbers)
  const recSkuVariantNumbers = useRecommendationStore((x) => x.skuVariantNumbers)
  const setSkuNumbers = useRecommendationStore((x) => x.setSkuNumbers)
  const skuBaseNumber = useProductPageStore((x) => x.skuBaseNumber)
  const skuVariantNumber = useProductPageStore((x) => x.skuVariantNumber)

  useEffect(() => {
    if (!recSkuBaseNumbers?.includes(skuBaseNumber) && !recSkuVariantNumbers?.includes(skuVariantNumber)) {
      setSkuNumbers(skuBaseNumber, skuVariantNumber)
    }
  }, [skuBaseNumber, skuVariantNumber])

  useEffect(() => {
    if (isLoading || (!isLoading && section)) {
      setIsCompareToolPresent(true)
    } else if (!isLoading && !section) {
      setIsCompareToolPresent(false)
    }
  }, [isLoading, section])

  return (
    <RecommendationSection
      section={'PDP_Compare'}
      numberOfSkeletons={7}
      nextLink
      prefetch={false}
      onClick={scrollToTopAndStartNavigation}
      skeletonType={'comparison'}
    />
  )
}

export default ProductCompare
